const DEPOSIT_TYPE = Object.freeze({
  nullAmount: 'null',
  fullAmount: 'full_amount',
  halfAmount: 'half_amount',
  quarterAmount: 'quarter_amount',
  customAmount: 'custom_amount',
});

export default DEPOSIT_TYPE;
